import React from 'react';
import produce from 'immer';
import { MetricCountBySelection } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/metric-count-by-menu';
import { SCDOffsetBlock } from 'common/query-builder/query-entry-section/components/scd-offset';
import { RevenueChangeBlock } from 'common/query-builder/query-entry-section/components/revenue-change';
import { Property } from 'common/query-builder/query-block/properties-menu/types';
import { PropertySectionItem } from 'common/query-builder/query-block/properties-menu/item-menu-types';
import type { RowProps } from '../catalog';
export function UserMetricMeasurement(props: RowProps) {
  const aggregationProperty = props.entry.measurement.property as Property;
  return <>
      <MetricCountBySelection {...props} data-sentry-element="MetricCountBySelection" data-sentry-source-file="measurement.tsx" />

      {/* SCD property aggregation offset */}
      {(aggregationProperty === null || aggregationProperty === void 0 ? void 0 : aggregationProperty.scdOffset) && <SCDOffsetBlock property={aggregationProperty} onChange={property => props.updateEntry(produce(props.entry, draft => {
      draft.measurement.property = property as PropertySectionItem;
    }))} />}

      {/* computed revenue options */}
      {(aggregationProperty === null || aggregationProperty === void 0 ? void 0 : aggregationProperty.behavior) && <RevenueChangeBlock behavior={aggregationProperty.behavior} onChange={updatedBehavior => props.updateEntry(produce(props.entry, draft => {
      (draft.measurement.property! as Property).behavior = updatedBehavior;
    }))} />}
    </>;
}